import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const surrogateId: AnswerPathTreeNode = { path: 'surrogateId', nodeId: NodeIds.insuredSurrogateId };
